export const environment = {
  production: true,
  apiBaseUrl: 'https://api-stage.appoint360.com/api/',
  apiBaseUrlSignalR: 'https://api-stage.appoint360.com/',
  successMessageLifeTime: 5000,
  warningMessageLifeTime: 5000,
  errorMessageLifeTime: 10000,
  PAYMENT_TIMEOUT_SECONDS: 3 * 60, // 3 minutes
  nextBillionApiKey: '397d43c0cd494363a436843c1b2f4b90'
};
